import {JetView} from "webix-jet";

/**
 * AgeView class extends JetView to create a chart displaying user balances by age.
 */
export default class AgeView extends JetView {
	/**
	 * Configures the view layout and components.
	 * @returns {Object} The configuration object for the view.
	 */
	config(){
		const _ = this.app.getService("locale")._; // Localization service for translated strings
		return {
			type:"clean", // Clean layout type
			rows:[
				{ 
					template:_("Saldo Actual de usuarios por Edades"), // Header template with localized text
					type:"header", 
					css:"webix_header chart_header" // CSS class for styling the header
				},
				{
					view:"chart", // Chart component
					type:"scatter", // Scatter chart type
					localId:"chart", // Local ID for referencing the chart
					padding:{
						top:10, // Padding on top
						left:50, // Padding on left
						bottom:40 // Padding on bottom
					},
					/**
					 * Function to calculate xValue based on user's age.
					 * @param {Object} obj - The data object containing user information.
					 * @returns {number} The calculated age in years.
					 */
					xValue:obj => {
						return (new Date().getFullYear() - new Date(obj.age).getFullYear()); // Calculate age
					},
					value:"#money#", // Field to display on the y-axis
					item:{
						borderColor:"#fff", // Border color of the chart items
						color:"#8664C6", // Fill color of the chart items
						shadow:false, // Disable shadow for items
						radius:7, // Radius of the chart items
						type:"d" // Type of the chart items
					},
					xAxis:{
						start:22, // Starting point for the x-axis
						step:4, // Step size for the x-axis
						lines:false, // Disable grid lines
						color:"#EDEFF0", // Color of the x-axis
						title:"Edad" // Title of the x-axis
					},
					yAxis:{
						start:0, // Starting point for the y-axis
						step:500, // Step size for the y-axis
						color:"#fff", // Color of the y-axis
						lineColor:"#EDEFF0", // Line color of the y-axis
						title:"Saldo" // Title of the y-axis
					},
					tooltip:{
						template:"<b>#user#</b><br>$#money#" // Tooltip template for displaying user and money
					}
				}
			]
		};
	}

	/**
	 * Initializes the view and sets up event listeners.
	 */
	init(){
		const cur_user = this.getParam("league", true); // Retrieve the current user parameter
		var vthis = this; // Preserve context for the event handler
		this.on(this.app, "statisticsAgent:ageUsersStat", data => {
			vthis.$$("chart").clearAll(); // Clear existing chart data
			vthis.$$("chart").parse(data); // Parse new data into the chart
		});	
	}
}

// FILE DOCUMENTED
